import { useEffect, useState } from 'react';
import chroma from 'chroma-js';
import { readComputedBackground, parsePx } from './use-resolved-block-style';

export interface ResolvedDividerStyle {
  background?: string;
  lineColor?: string;
  lineStyle?: string;
  paddingTop?: number;
  paddingRight?: number;
  paddingBottom?: number;
  paddingLeft?: number;
}

export function useResolvedDividerStyle(blockId: string): ResolvedDividerStyle {
  const [resolved, setResolved] = useState<ResolvedDividerStyle>({});
  useEffect(() => {
    const cell = document.querySelector(`[data-block-id="${CSS.escape(blockId)}"]`);
    if (!cell) return;
    const cellComputed = getComputedStyle(cell);
    const line = cell.querySelector(':scope > div');
    const lineComputed = line ? getComputedStyle(line) : undefined;
    setResolved({
      background: readComputedBackground(cell),
      lineColor:
        lineComputed && chroma.valid(lineComputed.borderTopColor)
          ? chroma(lineComputed.borderTopColor).hex()
          : undefined,
      lineStyle: lineComputed?.borderTopStyle,
      paddingTop: parsePx(cellComputed.paddingTop),
      paddingRight: parsePx(cellComputed.paddingRight),
      paddingBottom: parsePx(cellComputed.paddingBottom),
      paddingLeft: parsePx(cellComputed.paddingLeft),
    });
  }, [blockId]);
  return resolved;
}
